module.exports = __webpack_public_path__ + "img/yomaro-logo.c56f68d9.png";